module.exports = __webpack_public_path__ + "static/media/1POLICY22.9ff6fcd9.jpg";